import moment from "moment";

const SalesPeriodCustomTick = ({ x, y, payload, index, data, dateType }) => {
  const day = moment(payload.value).format("D일");
  const month = moment(payload.value).format("M월");
  const year = moment(payload.value).format("YY년");

  const shouldShowMonth =
    index === 0 ||
    (data &&
      data[index - 1] &&
      moment(payload.value).format("M") !==
        moment(data[index - 1].date).format("M"));

  const shouldShowYear =
    index === 0 ||
    (data &&
      data[index - 1] &&
      moment(payload.value).format("YY") !==
        moment(data[index - 1].date).format("YY"));

  return (
    <g transform={`translate(${x},${y})`}>
      <text x={0} y={0} dy={30} textAnchor="middle">
        <tspan
          x="0"
          dy="0"
          fill="#aaa"
          style={{
            fontFamily: "Pretendard",
            fontWeight: 400,
            fontSize: 14,
            lineHeight: "20.25px",
          }}
        >
          {dateType !== "month" ? day : month}
        </tspan>
        {dateType !== "month" && shouldShowMonth ? (
          <tspan
            x="0"
            dy="20"
            fill="rgba(181, 181, 181, 0.5)"
            style={{
              fontFamily: "Pretendard",
              fontWeight: 400,
              fontSize: 14,
              lineHeight: "20.25px",
            }}
          >
            {month}
          </tspan>
        ) : null}
        {dateType === "month" && shouldShowYear ? (
          <tspan
            x="0"
            dy="20"
            fill="rgba(181, 181, 181, 0.5)"
            style={{
              fontFamily: "Pretendard",
              fontWeight: 400,
              fontSize: 14,
              lineHeight: "20.25px",
            }}
          >
            '{year}
          </tspan>
        ) : null}
      </text>
    </g>
  );
};

export default SalesPeriodCustomTick;
